import React from "react";

import { Button, Checkbox, Row } from "antd";
import moment from "moment";

const InsightListComponent = ({
  item,
  selectInsightList,
  handleSelectInsightClick,
}) => {
  return (
    <>
      <Row
        justify={`space-between`}
        align={`middle`}
        style={{ rowGap: "0.5em" }}
      >
        <div className={`insight-each-header`}>
          <Checkbox
            id={item.id}
            checked={selectInsightList.includes(item.id)}
            onChange={handleSelectInsightClick}
          />
          {item.positive ? (
            <Button size={`small`} className={`positive`}>
              긍정
            </Button>
          ) : (
            <Button size={`small`} className={`negative`}>
              부정
            </Button>
          )}
          <Button size={`small`}>{item.category_name}</Button>

          {item.important && (
            <img
              className={`yellow-star`}
              alt={"중요 아이콘"}
              src={`/assets/images/yellow-star.png`}
            />
          )}
        </div>
        <Row align={`middle`} style={{ gap: "8px", rowGap: "8px" }}>
          <p className={`user-name`}>{item.created_by_name}</p>
          <span className={`created_at`}>
            {moment(item.updated_at).format("YY.MM.DD")}
          </span>
        </Row>
      </Row>
      <div
        dangerouslySetInnerHTML={{
          __html: item.content,
        }}
      />
    </>
  );
};

export default InsightListComponent;
